import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient, type GraphQLResult } from "aws-amplify/api";
import { createExport } from "@/graphql/mutations";
import { GraphQLError } from "graphql";

const client = generateClient();

export const exportGridState = create<State<boolean | null>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const exportGridIsloading = () =>
  exportGridState.setState(() => ({
    isLoading: true,
    isFetching: false,
    data: null,
    error: null,
  }));
export const exportGridIsError = (error: GraphQLError[] | undefined) =>
  exportGridState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
    isFetching: false,
  }));
export const exportGridIsSuccess = (queryResult: boolean) =>
  exportGridState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
    isFetching: false,
  }));

export const resetexportGridState = () =>
  exportGridState.setState(() => exportGridState.getInitialState());

type exportGridParams = {
  gridId: string;
};

export const exportGrid = async (params: exportGridParams) => {
  exportGridIsloading();
  const { gridId } = params;

  try {
    const { data } = await client.graphql({
      query: createExport,
      variables: {
        gridId,
      },
    });

    exportGridIsSuccess(data.createExport);
  } catch (e) {
    const graphQl = e as GraphQLResult<boolean>;
    exportGridIsError(graphQl.errors);
  }
};
